<div
  class="input-field"
  [class.input-field--error]="error()"
  [class.input-field--disabled]="isDisabled()"
>
  @if (label()) {
    <label [for]="id()" class="input-field__label">{{ label() }}</label>
  }
  <div
    class="input-field__wrapper"
    [class.input-field__wrapper--focused]="hasFocus()"
    [class.input-field__wrapper--error]="error()"
  >
    <input
      [id]="id()"
      [type]="type()"
      [placeholder]="placeholder()"
      [value]="internalValue()"
      [disabled]="isDisabled()"
      [attr.aria-label]="ariaLabel() || null"
      class="input-field__input"
      (input)="onInput($event)"
      (focus)="hasFocus.set(true)"
      (blur)="onBlur()"
    />
  </div>
  @if (error()) {
    <span class="input-field__error" role="alert">{{ error() }}</span>
  }
</div>
